<p class="apto-form-control--form-value">
    <ng-content></ng-content>
</p>